const DocumentExtractionFieldsTabTestIdsScope = {
  DOCUMENT_EXTRACTION_FIELDS: 'document-extraction-fields',
};

export const DocumentExtractionFieldsTabTestIds = {
  EDIT_CANCEL_BUTTON: `${DocumentExtractionFieldsTabTestIdsScope.DOCUMENT_EXTRACTION_FIELDS}.edit-cancel-button`,
  EDIT_SAVE_BUTTON: `${DocumentExtractionFieldsTabTestIdsScope.DOCUMENT_EXTRACTION_FIELDS}.edit-save-button`,
  RERUN_BUTTON: `${DocumentExtractionFieldsTabTestIdsScope.DOCUMENT_EXTRACTION_FIELDS}.rerun-button`,
  EDIT_ALL_BUTTON: `${DocumentExtractionFieldsTabTestIdsScope.DOCUMENT_EXTRACTION_FIELDS}.edit-all-button`,
  EDIT_ALL_LINK: `${DocumentExtractionFieldsTabTestIdsScope.DOCUMENT_EXTRACTION_FIELDS}.edit-all-link`,
  CORRECT_BUTTON: `${DocumentExtractionFieldsTabTestIdsScope.DOCUMENT_EXTRACTION_FIELDS}.correct-button`,
  NOT_FOUND_ACCORDION: `${DocumentExtractionFieldsTabTestIdsScope.DOCUMENT_EXTRACTION_FIELDS}.not-found-accordion`,
  SORT_LOW_CONFIDENCE_TOGGLE: `${DocumentExtractionFieldsTabTestIdsScope.DOCUMENT_EXTRACTION_FIELDS}.sort-low-confidence-toggle`,
};
